import React from 'react';
import EmployeeProfileFormFields from '../../../components/profile/EmployeeProfileFormFields';

const EmployeeSelfProfileModal = ({
    open,
    onClose,
    form,
    onChange,
    onSubmit,
    submitting,
    inputClass,
    backendToken,
    walletAddress,
    companyName = '',
    dismissible = false,
}) => {
    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
            onClick={dismissible ? onClose : undefined}
            role="presentation"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-2xl border border-zinc-200 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-950"
                role="dialog"
                aria-modal="true"
            >
                <div className="sticky top-0 z-[1] flex items-center justify-between border-b border-zinc-200 bg-white px-6 py-4 dark:border-zinc-800 dark:bg-zinc-950">
                    <div>
                        <h3 className="text-lg font-semibold text-zinc-900 dark:text-white">
                            Complete your profile
                        </h3>
                        <p className="mt-0.5 text-xs text-zinc-500 dark:text-zinc-500">
                            {companyName
                                ? `You are onboarded at ${companyName}. Add optional details so your team recognizes you.`
                                : 'Add optional details for your team directory.'}
                        </p>
                    </div>
                    {dismissible ? (
                        <button
                            type="button"
                            onClick={onClose}
                            className="flex h-9 w-9 items-center justify-center rounded-lg bg-zinc-100 text-zinc-600 transition-colors hover:bg-zinc-200 dark:bg-zinc-800 dark:text-zinc-300"
                        >
                            <i className="fa-solid fa-xmark" />
                        </button>
                    ) : null}
                </div>

                <form onSubmit={onSubmit} className="space-y-5 px-6 py-6">
                    <EmployeeProfileFormFields
                        form={form}
                        onChange={onChange}
                        inputClass={inputClass}
                        backendToken={backendToken}
                        walletAddress={walletAddress}
                        disabled={submitting}
                        showWallet={false}
                        showCompensation={false}
                    />
                    <div className="flex justify-end gap-3 border-t border-zinc-200 pt-4 dark:border-zinc-800">
                        {dismissible ? (
                            <button
                                type="button"
                                onClick={onClose}
                                className="rounded-xl border border-zinc-300 bg-zinc-100 px-4 py-2 text-sm font-semibold text-zinc-800 dark:border-zinc-600 dark:bg-zinc-800/70 dark:text-zinc-200"
                            >
                                Later
                            </button>
                        ) : null}
                        <button
                            type="submit"
                            disabled={submitting}
                            className="rounded-xl bg-teal-700 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-800 disabled:opacity-50 dark:bg-teal-600"
                        >
                            {submitting ? 'Saving…' : 'Save profile'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmployeeSelfProfileModal;
